import { buildHsocPriceDisplay } from 'pricing-pages-ui-hsoc/components/merch-card-grid/HsocMerchCardPrice';
import FreeProducts from 'merchandise-lib/constants/FreeProduct';
import { PublicHsocMerchCardCTAs } from './PublicHsocMerchCardCTAs';

/* Fixed display order for HSOC tiers. Only tiers present in the response are
 * rendered, in this order. */
import { jsx as _jsx } from "react/jsx-runtime";
const HSOC_TIER_ORDER = ['FREE', 'STARTER', 'PROFESSIONAL', 'ENTERPRISE'];

/* The subset of the tier option this mapper reads today. Badge is still a
 * placeholder (TODO(#22236)) — the V2 tier data does not yet expose a badge
 * field to widen this pick with. */

/*
 * Maps the HSOC V2 productsByTier response into the merch card grid's card
 * props. The CTA cluster is built here (per public context) from the tier's
 * purchaseMotions so purchaseMotion never enters the shared grid package.
 *
 * Price is picked from the tier's pricing for the selected term; badge is
 * still a placeholder (TODO(#22236)).
 */
export function mapProductsByTierToCards(productsByTier, currencyCode, term) {
  if (!productsByTier) {
    return [];
  }
  return HSOC_TIER_ORDER.filter(tierName => tierName in productsByTier).map(tierName => {
    const tierOption = productsByTier[tierName];
    const tierApiName = tierName === 'FREE' && !tierOption.productApiName ? FreeProducts.HUBSPOT_FREE : tierOption.productApiName;
    return {
      tierApiName,
      tierName,
      price: buildHsocPriceDisplay(tierOption.pricing, term, currencyCode, tierName),
      /* feature.name is a display string returned by the API, not an i18n
       * key — it must not be wrapped in I18n.text(). */
      features: tierOption.featuresForTier.map(feature => ({
        key: feature.name,
        label: feature.name,
        isAvailable: true
      })),
      ctas: /*#__PURE__*/_jsx(PublicHsocMerchCardCTAs, {
        tierName: tierName,
        productApiName: tierApiName,
        motions: tierOption.purchaseMotions,
        currencyCode: currencyCode,
        term: term
      })
    };
  });
}